export default {
  menu: 'Teststart',
  welcome: 'Willkommen!',
  lead: 'Sie sind jetzt dabei, die folgenden tests durchzuführen:',
  continue: 'Weitergehen',
  register: 'Rekord',
  first_name: 'Vorname',
  last_name: 'Nachname',
  age: 'Alter',
  application: 'Gesuchte Position (wenn nicht zutreffend, schreiben Sie ”X“)',
  current: 'Aktuelle beschäftigung',
  gender: 'Sex'
}
